/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Members_EmptyInputs */

const th_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีสมาชิกในองค์กรนี้`)
};

const en_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody belongs to this organisation yet.`)
};

const ja_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この団体にはまだメンバーがいません。`)
};

const zh_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此组织中还没有任何人。`)
};

const es_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no pertenece nadie a esta organización.`)
};

const pt_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém pertence a esta organização ainda.`)
};

const id_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada seorang pun di organisasi ini.`)
};

const fr_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne n’appartient encore à cette organisation.`)
};

const tl_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang sinuman sa organisasyong ito.`)
};

const vi_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa ai thuộc tổ chức này.`)
};

const ko_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 조직에 아직 아무도 없습니다.`)
};

const de_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Organisation gehört noch niemand an.`)
};

const ru_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой организации пока никого нет.`)
};

const tr_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kuruluşta henüz kimse yok.`)
};

const it_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è ancora nessuno in questa organizzazione.`)
};

const pl_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tej organizacji nie ma jeszcze nikogo.`)
};

const uk_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цій організації поки нікого немає.`)
};

const hi_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस संगठन में अभी कोई नहीं है।`)
};

const ar_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد أحد في هذه المؤسسة بعد.`)
};

const ms_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesiapa dalam organisasi ini.`)
};

const bn_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই সংস্থায় এখনও কেউ নেই।`)
};

const zh_tw2_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個組織中還沒有任何人。`)
};

const zh_hk2_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個組織中還沒有任何人。`)
};

const ur_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ادارے میں ابھی کوئی نہیں۔`)
};

const fa_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز کسی در این سازمان نیست.`)
};

const sw_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mtu kwenye shirika hili bado.`)
};

const nl_org_members_empty = /** @type {(inputs: Org_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er zit nog niemand in deze organisatie.`)
};

/**
* | output |
* | --- |
* | "Nobody belongs to this organisation yet." |
*
* @param {Org_Members_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_members_empty = /** @type {((inputs?: Org_Members_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Members_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_members_empty(inputs)
	if (locale === "ja") return ja_org_members_empty(inputs)
	if (locale === "zh") return zh_org_members_empty(inputs)
	if (locale === "es") return es_org_members_empty(inputs)
	if (locale === "pt") return pt_org_members_empty(inputs)
	if (locale === "id") return id_org_members_empty(inputs)
	if (locale === "fr") return fr_org_members_empty(inputs)
	if (locale === "tl") return tl_org_members_empty(inputs)
	if (locale === "vi") return vi_org_members_empty(inputs)
	if (locale === "ko") return ko_org_members_empty(inputs)
	if (locale === "de") return de_org_members_empty(inputs)
	if (locale === "ru") return ru_org_members_empty(inputs)
	if (locale === "tr") return tr_org_members_empty(inputs)
	if (locale === "it") return it_org_members_empty(inputs)
	if (locale === "pl") return pl_org_members_empty(inputs)
	if (locale === "uk") return uk_org_members_empty(inputs)
	if (locale === "hi") return hi_org_members_empty(inputs)
	if (locale === "ar") return ar_org_members_empty(inputs)
	if (locale === "ms") return ms_org_members_empty(inputs)
	if (locale === "bn") return bn_org_members_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_org_members_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_org_members_empty(inputs)
	if (locale === "ur") return ur_org_members_empty(inputs)
	if (locale === "fa") return fa_org_members_empty(inputs)
	if (locale === "sw") return sw_org_members_empty(inputs)
	if (locale === "nl") return nl_org_members_empty(inputs)
	return en_org_members_empty(inputs)
});